import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { Button, Refresh2Icon } from '@blade/ui-kit'
import { type Error } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

import type { ButtonProps } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  requestState: AsyncStateN.AsyncStateN<Error.UnknownError, unknown>
  onReset: () => void
} & ClassNameProps

export const TradeSettingsFormAction: React.FC<Props> = ({
  onReset,
  requestState,
}) => {
  const { t } = useTranslation()
  const { formState } = useFormContext()

  const renderSaveButton = () => {
    const args = {
      busy: AsyncStateN.isLoading(requestState),
      variant: 'solid',
      color: 'primary',
      size: 'xs',
      radius: 'rounded',
      disabled: !formState.isValid,
    } satisfies ButtonProps

    return (
      <ButtonSolid {...args} type="submit">
        {t('common.save')}
      </ButtonSolid>
    )
  }

  return (
    <Root>
      {renderSaveButton()}
      <ButtonLink
        variant="ghost"
        size="xs"
        iconLeft={<Refresh2Icon />}
        onClick={onReset}
      >
        {t('trade_settings.reset_settings')}
      </ButtonLink>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  border-top: 1px solid var(--backgroundA-3);

  padding: 10px;
`

const ButtonSolid = styled(Button)`
  min-width: 100px;
`

// TODO: ui-kit button candidate
const ButtonLink = styled(Button)`
  color: var(--textA-8);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  padding-inline: 0;

  &:hover {
    background: transparent;
  }
`
